module.exports = __webpack_public_path__ + "img/img25.ecb83658.png";